import { useState, useEffect } from "react";
import { Typography, Box, InputBase, Button } from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseWalletManage } from "./UseWalletManage";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import RequastDetails from "./RequastDetails";
import WalletOffers from "./WalletOffers";

export default function WalletManage() {
  const navigate = useNavigate();
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getRequestWalletList } = UseWalletManage();
  const [walletRes, setWalletRes] = useState();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("ShamsiLogdate", "Desc");

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );

  const [openDetail, setOpenDetail] = useState({
    show: false,
    mobile: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getRequestWalletList(
      myPc,
      search,
      (Wallets) => {
        setWalletRes(Wallets);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    return navigate("/discountmanagment/discountCode/addCode", {
      state: {
        myPc: myPc,
        search: search,
      },
    });
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 130,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "fullName",
      headerName: "نام",
      width: 150,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLogdate",
      headerName: "تاریخ",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiLogdate}
          </Typography>
        );
      },
    },
    {
      field: "title",
      headerName: "عنوان",
      width: 130,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.title}
          </Typography>
        );
      },
    },
    {
      field: "cost",
      headerName: "درخواستی",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },

    {
      field: "جزئیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "جزئیات",
      renderCell: (cellValues) => {
        return (
          <Button
            color="secondary"
            onClick={() => {
              setOpenDetail({ show: true, id: cellValues.row.id });
            }}
            variant="contained"
          >
            جزئیات
          </Button>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/walletManagment",
          },
        ],
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box sx={{ height: "30rem", mb: 2 }}>
          {walletRes ? (
            <DataGrid
              className="ltr-grid"
              localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
              columns={columns}
              pageSize={walletRes.pageCondition.pageCount}
              rows={walletRes.wallets}
              paginationMode="server"
              page={walletRes.pageCondition.page - 1}
              onPageChange={(page) => {
                updatePage(page + 1);
              }}
              rowCount={walletRes.pageCondition.totalItemCount}
              enableRangeSelection={true}
              disableColumnMenu
              hideFooterSelectedRowCount
              components={{
                Pagination: CustomPagination,
              }}
              componentsProps={{
                pagination: {
                  newFunc: newFunc,
                  scrollTo: myPc.scrollTo,
                  isLtr: true,
                  rowCount:
                    walletRes && walletRes.pageCondition.totalItemCount
                      ? walletRes.pageCondition.totalItemCount
                      : "",
                  nofab: true,
                },
              }}
              initialState={{
                sorting: {
                  sortModel: [
                    {
                      field: deCapitalizeFirstLetter(myPc.sortColumn),
                      sort: deCapitalizeFirstLetter(myPc.sortOrder),
                    },
                  ],
                },
                pagination: {
                  page: myPc.page,
                },
              }}
              sx={{
                "& .MuiDataGrid-cell:focus": {
                  outline: "none",
                },
                "&  .MuiDataGrid-columnHeader:focus-within": {
                  outline: "none",
                },
                "&  .MuiDataGrid-cell:focus-within ": {
                  outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                },
                "& .muirtl-hnxuso-MuiDataGrid-root .MuiDataGrid-cell:focus-within":
                  {
                    outline: "solid rgba(97, 181, 55, 0.5) 0px !important",
                  },
                "& .MuiDataGrid-cell:hover": {
                  opacity: "80%",
                  cursor: "pointer",
                },
                "& .MuiDataGrid-virtualScrollerRenderZone": {
                  width: "100% !important",
                },
                "& .primary": {
                  width: "100%",
                  backgroundColor: "#e6d0ff !important",
                },
                "& .none": {
                  width: "100%",
                  backgroundColor: "#fff !important",
                },
                "& .Green": {
                  backgroundColor: "#56ff004f !important",
                },
                "& .red": {
                  backgroundColor: "#ff9c9c !important",
                },
              }}
              getRowClassName={(params) => {
                if (params.row.type) {
                  return "Green";
                } else {
                  return "red";
                }
              }}
              onSortModelChange={(model) => {
                updateSort(
                  model[0].field,
                  model[0].sort == "asc" ? "asc" : "desc"
                );
              }}
              sortingOrder={["desc", "asc"]}
              sortingMode="server"
            />
          ) : (
            <ProgressCom></ProgressCom>
          )}
        </Box>
        <Box>
          <WalletOffers />
        </Box>
      </Box>

      {openDetail.show && (
        <RequastDetails
          CallBack={() => {
            getRequestWalletList(
              myPc,
              search,
              (Wallets) => {
                setWalletRes(Wallets);
              },
              false
            );
          }}
          openDetail={openDetail}
          setOpenDetail={setOpenDetail}
        />
      )}
    </Detail>
  );
}
